import FeatureFlagged from 'dashboard/components/FeatureFlagged';
import InquiryBehavior from 'dashboard/components/InquiryDetails/InquiryBehavior';
import InquiryCollected from 'dashboard/components/InquiryDetails/InquiryCollected';
import InquiryDetailsLocation from 'dashboard/components/InquiryDetails/InquiryDetailsLocation';
import InquiryReusablePersonas from 'dashboard/components/InquiryDetails/InquiryReusablePersonas';
import InquiryRiskModel from 'dashboard/components/InquiryDetails/InquiryRiskModel';
import InquirySummary from 'dashboard/components/InquiryDetails/InquirySummary';
import { Document } from 'dashboard/models/document';
import { EnvironmentType } from 'dashboard/models/environment';
import { Inquiry } from 'dashboard/models/inquiry';
import { InquirySession } from 'dashboard/models/inquiry-session';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { InquiryShowViewInquiryTemplateVersion } from 'dashboard/models/inquiry-template-version';
import { ListMatch } from 'dashboard/models/list-match';
import { Report } from 'dashboard/models/report';
import { Selfie } from 'dashboard/models/selfie';
import { Template } from 'dashboard/models/template';
import { Verification } from 'dashboard/models/verification';
import { FeatureFlagsMap } from 'lib/interfaces/feature-flags';

interface InquiryDetailsProps {
  documents: Document[];
  inquiry: Inquiry;
  inquiryTemplateVersion: InquiryShowViewInquiryTemplateVersion | undefined;
  featureFlags: FeatureFlagsMap;
  isRedacted: boolean;
  listMatches: Record<string, ListMatch>;
  matchUrl: string;
  reports: Report[];
  selfies: Selfie[];
  sessions: Record<string, InquirySession>;
  template: InquiryTemplate | Template;
  verifications: Verification[];
  environmentType: EnvironmentType;
}

const InquiryDetails = ({
  documents,
  inquiry,
  inquiryTemplateVersion,
  featureFlags,
  isRedacted,
  listMatches,
  matchUrl,
  reports,
  selfies,
  sessions,
  template,
  verifications,
  environmentType,
}: InquiryDetailsProps) => {
  return (
    <>
      <InquirySummary inquiry={inquiry} listMatches={listMatches} verifications={verifications} />
      <InquiryCollected
        featureFlags={featureFlags}
        inquiry={inquiry}
        inquiryTemplateVersion={inquiryTemplateVersion}
        template={template}
        documents={documents}
        selfies={selfies}
        isRedacted={isRedacted}
        verifications={verifications}
        environmentType={environmentType}
      />
      <InquiryDetailsLocation
        isRedacted={isRedacted}
        verifications={verifications}
        reports={reports}
        sessions={sessions}
        matchUrl={matchUrl}
        environmentType={environmentType}
      />
      <FeatureFlagged
        featureFlag='dashboard:enable-inquiry-model-risk-label'
        fallback={<InquiryBehavior inquiry={inquiry} />}
      >
        <InquiryRiskModel inquiry={inquiry} />
      </FeatureFlagged>
      {
        // The reusable persona is not tied to the inquiry.
        inquiry.attributes['reusable-persona-risk-signals']?.['num-unique-ip-addresses'] && (
          <FeatureFlagged featureFlag='inquiry:enable-reusable-personas'>
            <InquiryReusablePersonas inquiry={inquiry} />
          </FeatureFlagged>
        )
      }
    </>
  );
};

export default InquiryDetails;
